export default __webpack_public_path__ + "img/img_mazuin-1a316c932d6c242936cb6dc4c843ddff.jpg";